export default __webpack_public_path__ + "static/media/csalad.b114273c.png";